/*
  Import all Angular components via ES6 imports and register them
*/
import LandingpageController from '../controllers/LandingpageController';
import HomeController from '../controllers/HomeController';
import FormatHTML from '../services/FormatHTML';

angular.module('dmsGenerali', ['ngRoute', 'ngAnimate', 'ngSanitize', 'angular-ladda'])
	.controller('LandingpageController', LandingpageController)
	.controller('HomeController', HomeController)
	.directive('compile', ($compile, $timeout)=> {
		return {
			restrict:'A',
			link: (scope, elem, attrs)=> {
				$compile(elem.contents())(scope);
			}
		};
	}).directive('bindHtmlCompile', ['$compile', function ($compile) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return scope.$eval(attrs.bindHtmlCompile);
                }, function (value) {
                    // In case value is a TrustedValueHolderType, sometimes it
                    // needs to be explicitly called into a string in order to
                    // get the HTML string.
                    element.html(value && value.toString());
                    // If scope is provided use it, otherwise use parent scope
                    var compileScope = scope;
                    if (attrs.bindHtmlScope) {
                        compileScope = scope.$eval(attrs.bindHtmlScope);
                    }
                    $compile(element.contents())(compileScope);
                });
            }
        };
    }]).filter('camelCase',function(){
		return function(input) {
			if (input === undefined) {
				return;
			}

			var str_lower = input.toLowerCase(),
				str_split = str_lower.split(" ");

			for (var i in str_split) {
				var str = str_split[i];

				str_split[i] = str.substring(0, 1).toUpperCase() + str.substring(1);
			}

			return str_split.join(" ");
		};
	}).filter('trustAsHtml', ['$sce', function($sce){
		return function(input) {
			return $sce.trustAsHtml(input);
		};
	}]).filter('formatHtml', ['$sce', ($sce)=>{
		return function(input) {
			var content = new FormatHTML();
			
			return content.showString(input);
		};
	}]).config(['$routeProvider', '$locationProvider' , ($routeProvider, $locationProvider)=> {
		$locationProvider.html5Mode({
			enabled: true,
			requireBase: true
		});
	}]);
